import React, { useContext } from "react";
import { ProductContext } from "../components/context/Context";
import { Link } from "react-router-dom";

const Details = () => {
  const {
    state: { detailProduct },
    addToCart,
  } = useContext(ProductContext);

  const {
    id,
    company,
    title,
    img,
    price,
    discountPrice,
    info,
    inCart,
  } = detailProduct;

  return (
    <div className="container">
      <h1 style={{ marginLeft: "2.4rem" }}>Details</h1>
      <div className="col-md-8">
        <div className="product-content-right">
          <div className="product-breadcroumb">
            <Link to="/">Home</Link>
            <Link to="">Category Name</Link>
            <Link to="">{title}</Link>
          </div>

          <div className="row">
            <div className="col-sm-6">
              <div className="product-images">
                <div className="product-main-img">
                  <img src={img} alt="" />
                </div>

                <div className="product-gallery">
                  <img src="img/product-thumb-1.jpg" alt="" />
                  <img src="img/product-thumb-2.jpg" alt="" />
                  <img src="img/product-thumb-3.jpg" alt="" />
                </div>
              </div>
            </div>

            <div className="col-sm-6">
              <div className="product-inner">
                <h2 className="product-name">{title}</h2>
                <div className="product-inner-price">
                  <h4>
                    Price : <ins>${price}</ins> <del>${discountPrice}</del>
                  </h4>
                </div>

                {/* <form action="" className="cart">
                  <div className="quantity">
                    <input
                      type="number"
                      size="4"
                      className="input-text qty text"
                      title="Qty"
                      value="1"
                      name="quantity"
                      min="1"
                      step="1"
                    />
                  </div>
                  <br />
                  <br />
                </form> */}
                <button
                  className="add_to_cart_button"
                  type="submit"
                  style={{ height: "3.2rem", width: "10rem", padding: "0" }}
                  disabled={inCart ? true : false}
                  onClick={() => addToCart(id)}
                >
                  {inCart ? (
                    <span className="text-capitalize mb-0" disabled>
                      in Cart
                    </span>
                  ) : (
                    <span>Add to cart</span>
                  )}
                </button>

                <Link
                  to="/"
                  className="add_to_cart_button"
                  type="submit"
                  style={{ marginTop: "1rem" }}
                >
                  Back To Products
                </Link>

                <div role="tabpanel">
                  <h2>Product Description</h2>
                  <p>{info}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Details;
